import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Input, message } from 'antd';
import { FaRegEdit } from 'react-icons/fa';
import { useCaseStudy } from '../../hooks/useCaseStudy'; // adjust path as needed

const EditCase = ({ caseId, caseData, onEditSuccess }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = useState(null);

  const { useUpdateCaseStudy } = useCaseStudy();
  const updateCaseMutation = useUpdateCaseStudy();

  useEffect(() => {
    if (caseId && caseData?.length > 0) {
      const currentCase = caseData.find(item => item.id === caseId);
      if (currentCase) {
        setInitialValues(currentCase);
        form.setFieldsValue({
          title: currentCase.title,
          content: currentCase.content,
        });
      }
    }
  }, [caseId, caseData, form]);

  const showModal = () => {
    if (initialValues) {
      form.setFieldsValue({
        title: initialValues.title,
        content: initialValues.content,
      });
    }
    setIsModalOpen(true);
  };

  const handleCancel = () => setIsModalOpen(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      await updateCaseMutation.mutateAsync({
        id: caseId,
        data: values,
      });
      message.success('Case updated successfully');
      setIsModalOpen(false);
      if (onEditSuccess) onEditSuccess();
    } catch (error) {
      message.error('Failed to update case');
    }
  };

  return (
    <>
      <Button
        onClick={showModal}
        icon={<FaRegEdit />}
        type="primary"
        style={{ backgroundColor: '#1890ff' }}
      >
        Edit
      </Button>

      <Modal
        title="Edit Case Study"
        open={isModalOpen}
        onCancel={handleCancel}
        okText="Save Changes"
        onOk={handleSubmit}
        confirmLoading={updateCaseMutation.isLoading}
        destroyOnClose
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="title"
            label="Title"
            rules={[{ required: true, message: 'Enter title' }]}
          >
            <Input placeholder="Please enter the title you want to update" />
          </Form.Item>
          <Form.Item
            name="content"
            label="Content"
            rules={[{ required: true, message: 'Enter content' }]}
          >
            <Input.TextArea
              rows={4}
              placeholder="Please enter the content you want to update"
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EditCase;
